<template>
  <div :class="{ 'opacity-50 cursor-not-allowed': inProgress || !isLeader }">
    <div
      v-if="isSubmitted && errors == null"
      class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4"
    >
      <p class="mb-0">
        <strong class="font-bold">{{ $t("form.submitted") }}</strong>
      </p>
    </div>
    <div
      v-if="errors || (formData && formData.started && !formData.complited)"
      class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4"
      role="alert"
    >
      <p class="mb-0">
        <strong class="font-bold">{{ $t("form.infinsh") }}</strong>
      </p>
    </div>
    <form
      v-if="formData"
      autocomplete="off"
      name="ecosystem-generic-form"
      @click="handleClick($event)"
      @submit.prevent="saveForm($event)"
    >
      <div v-for="(q, index) in formData.questions" :key="'A' + index">
        <div v-if="q.category_id === null">
          <div v-if="formData.startupNames && (formData.code_name == 'DECLARATION_DE_REALISATION' || formData.code_name == 'DECLARATION_DE_REALISATION levée de fonds') && (q.response_type == 31 || q.response_type == 10)">
            <q-form
              :question="{
                ...q,
                options: {
                  ...q.options,
                  startups: formData.startupNames
                },
                option: formData.startupNames
              }"
              :formType="formData.code_name"
              :responses="responses"
              :started="formData.started"
              :showError="showError"
              @governorate="governoratechange"
              :delegation="delegation"
              @data-emitted="handleDataFromChild"
              :data-to-pass="dataFromChild"
              :requestForm="true"
            ></q-form>
          </div>
          <div v-else-if="['INVESTOR_GUARANTEE_FORM', 'INVESTOR_CALL_GUARANTEE_FORM'].includes(formName) && q.response_type == 11 && ['section', 'division', 'groupe', 'classe'].includes(q.tag)">
            <q-form
              :question="q"
              :responses="responses"
              :formType=" formName ? formName : formData.code_name"
              @response-updated="handleResponseUpdate"
              @response-updated-labelRef="handleResponseUpdate2"
              @label-data="handleLabelData"
              :child-identifiant="dataIdentif"
              :child-legal-name="dataLegalName"
              :started="formData.started"
              :showError="showError"
              @governorate="governoratechange"
              @codePostal="handleCodePostal"
              :delegation="delegation"
              :inversedGovernerate="inversedGovernerate"
              @inversedGovernerate="InversedGovernerateChange"
              :inversedDelegation="inversedDelegation"
              @inversedDelegation="InversedDelegationChange"
              :codePostal="codePostal"
              :requestForm="true"
              :sections="sections"
              :divisions="relatedDivisions"
              :groups="relatedGroups"
              :classes="relatedClasses"
              @relatedDivisions="handleRelatedDivisions"
              @relatedGroups="handleRelatedGroups"
              @relatedClasses="handleRelatedClasses"
              @selectedDivision="handleSelectedDivisions"
              @selectedGroup="handleSelectedGroups"
            ></q-form>
          </div>
          <div v-else-if="['INVESTOR_GUARANTEE_FORM','INVESTOR_CALL_GUARANTEE_FORM'].includes(formData.code_name) ||
            ['INVESTOR_GUARANTEE_FORM','INVESTOR_CALL_GUARANTEE_FORM'].includes(formName)">
            <q-form
              :question="q"
              :responses="responses"
              :formType=" formName ? formName : formData.code_name"
              @response-updated="handleResponseUpdate"
              @response-updated-labelRef="handleResponseUpdate2"
              @label-data="handleLabelData"
              :child-identifiant="dataIdentif"
              :child-legal-name="dataLegalName"
              :started="formData.started"
              :showError="showError"
              @governorate="governoratechange"
              @codePostal="handleCodePostal"
              :delegation="delegation"
              :inversedGovernerate="inversedGovernerate"
              @inversedGovernerate="InversedGovernerateChange"
              :inversedDelegation="inversedDelegation"
              @inversedDelegation="InversedDelegationChange"
              :codePostal="codePostal"
              :requestForm="true"
              @input-change="handleInputChange"
              :liberation-value="participationLibérée"
            ></q-form>
          </div>
          <div v-else>
            <q-form
              :question="q"
              :responses="responses"
              :started="formData.started"
              :showError="showError"
              @governorate="governoratechange"
              :delegation="delegation"
              :requestForm="true"
            ></q-form>
          </div>
        </div>
      </div>
      <div v-for="(cat, index) in formData.categories" :key="'D' + index">
        <h2
          class="text-red text-lg text-bold mb-5 pb-2 py-6 border-red-light border-b"
        >
        {{cat.name}}
        </h2>
        <div v-for="(q, index) in formData.questions" :key="'B' + index">
          <div v-if="q.category_id === cat.id">
            <div v-if="(['INVESTOR_GUARANTEE_FORM','INVESTOR_CALL_GUARANTEE_FORM'].includes(formData.code_name) ||
            ['INVESTOR_GUARANTEE_FORM','INVESTOR_CALL_GUARANTEE_FORM'].includes(formName)) && !['section', 'division', 'groupe', 'classe'].includes(q.tag)">
              <q-form
                :question="q"
                :responses="responses"
                :formType=" formName ? formName : formData.code_name"
                @response-updated="handleResponseUpdate"
                @response-updated-labelRef="handleResponseUpdate2"
                @label-data="handleLabelData"
                :child-identifiant="dataIdentif"
                :child-legal-name="dataLegalName"   
                :started="formData.started"
                :showError="showError"
                @governorate="governoratechange"
                @codePostal="handleCodePostal"
                :codePostal="codePostal"
                :delegation="delegation"
                :inversedGovernerate="inversedGovernerate"
                @inversedGovernerate="InversedGovernerateChange"
                :inversedDelegation="inversedDelegation"
                @inversedDelegation="InversedDelegationChange"
                :requestForm="true"
                @input-change="handleInputChange"
                :liberation-value="participationLibérée"
              ></q-form>
            </div>
            <div v-else-if="['INVESTOR_GUARANTEE_FORM', 'INVESTOR_CALL_GUARANTEE_FORM'].includes(formName) && q.response_type == 11 && ['section', 'division', 'groupe', 'classe'].includes(q.tag)">
            <q-form
              :question="q"
              :responses="responses"
              :formType=" formName ? formName : formData.code_name"
              @response-updated="handleResponseUpdate"
              @response-updated-labelRef="handleResponseUpdate2"
              @label-data="handleLabelData"
              :child-identifiant="dataIdentif"
              :child-legal-name="dataLegalName"
              :started="formData.started"
              :showError="showError"
              @governorate="governoratechange"
              @codePostal="handleCodePostal"
              :delegation="delegation"
              :inversedGovernerate="inversedGovernerate"
              @inversedGovernerate="InversedGovernerateChange"
              :inversedDelegation="inversedDelegation"
              @inversedDelegation="InversedDelegationChange"
              :codePostal="codePostal"
              :requestForm="true"
              :sections="sections"
              :divisions="relatedDivisions"
              :groups="relatedGroups"
              :classes="relatedClasses"
              @relatedDivisions="handleRelatedDivisions"
              @relatedGroups="handleRelatedGroups"
              @relatedClasses="handleRelatedClasses"
              @selectedDivision="handleSelectedDivisions"
              @selectedGroup="handleSelectedGroups"
            ></q-form>
          </div>
            <div v-else>
              <q-form
                :question="q"
                :responses="responses"
                :started="formData.started"
                :showError="showError"
                @governorate="governoratechange"
                :delegation="delegation"
              ></q-form>
            </div>
            
          </div>
        </div>
      </div>

      <div
        v-if="currentUser.role != 'form-builder'"
        class="flex items-center justify-end w-auto bg-white shadow-box mt-4 sm:mt-8 p-4 sm:p-8 pb-2 -mx-3"
      >
        <sp-button theme="outline-blue" space="small" type="submit" :disabled="buttonDisabled">{{
          $t("form.send")
        }}</sp-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Fragment } from "vue-fragment";
import { debounce } from 'lodash';
import QForm from "@/components/Candidat/QForm.vue";
import Button from "@/components/spKit/Button.vue";
import { mapGetters, mapState } from "vuex";
import {
  DECLARATION_FORM_GET,
  DECLARATION_FORM_SAVE,
  FETCH_ECOSYSTEM_APPLICATION
} from "@/store/actions.type";
import {
  SET_ECOSYSTEM_MENU_ACTIVE,
  SET_PROGRESS
} from "@/store/mutations.type";
import { sections } from "@/common/sectionsData";
export default {
  name: "DeclarationForm",
  data() {
    return {
      ecoAppId: null,
      appType: null,
      formName: null,
      inProgress: false,
      responses: [],
      isSubmitted: false,
      showError: false,
      formData: null,
      target: "draft",
      isLeader: true,
      delegation: null,
      inversedGovernerate: null,
      inversedDelegation: null,
      dataFromChild: '',
      buttonDisabled: false,
      dataIdentif: '',
      dataLegalName: '',
      codePostal: null,
      labelData: '',
      relatedDivisions: [],
      relatedGroups: [],
      relatedClasses: [],
      sections: sections,
      selectedDivision: '',
      selectedGroup: '',
      participationLibérée: '',
    };
  },
  components: {
    "q-form": QForm,
    fragment: Fragment,
    "sp-button": Button
  },
  mounted() {
    this.$Progress.start();
    if (this.currentUser.role != "form-builder") {
      this.ecoAppId = this.$route.params.ecoAppId;
      this.appType = this.$route.params.appType;
      this.formName = this.upperlace(this.$route.params.formName);
      this.$store.dispatch(FETCH_ECOSYSTEM_APPLICATION, this.ecoAppId);
      this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
      this.getFormData();
    } else {
      this.$store
        .dispatch(GET_BUILDER_FORM_DATA, this.$route.params.id)
        .then(data => {
          this.formData = data.data.form;
        });
    }
    this.$Progress.finish();
    // Create a debounced version of the saveForm function
    this.saveForm = debounce(this.saveForm, 3000);
    // Call the debounced version of the saveForm function when the user clicks the submit button
    this.$watch('$refs.submitButton', () => {
      if (this.$refs.submitButton) {
        this.$refs.submitButton.addEventListener('click', this.debouncedSaveForm);
      }
    });
  },
  methods: {
    handleInputChange(value) {
      // Handle the emitted value from the child component
      this.participationLibérée = value;
    },
    getOptions(tag) {
      if (tag === 'section') return this.sections;
      if (tag === 'division') {
        return this.allDivisions;
      }
      if (tag === 'groupe') return this.allGroups;
      if (tag === 'classe') return this.allClasses;
      return [];
    },
    handleResponseUpdate(response) {
      this.dataIdentif = response;
    },
    handleResponseUpdate2(response) {
      this.dataLegalName = response;
    },
    handleCodePostal(data) {
      this.codePostal = data;
    },
    handleLabelData(response) {
      this.labelData = response;
    },
    handleDataFromChild(data) {
      this.dataFromChild = data;
    },
    governoratechange(data) {
      this.delegation = data;
    },
    InversedGovernerateChange(data) {
      this.inversedGovernerate = data;
    },
    InversedDelegationChange(data) {
      this.inversedDelegation = data;
    },
    handleClick(event) {
      this.target = event.target.name;
    },
    handleRelatedDivisions(data) {
      this.relatedDivisions = data;
    },
    handleRelatedGroups(data) {
      this.relatedGroups = data;
    },
    handleRelatedClasses(data) {
      this.relatedClasses = data;
    },
    handleSelectedDivisions(data) {
      this.selectedDivision = data;
    },
    handleSelectedGroups(data) {
      this.selectedGroup= data;
    },
    saveForm(event) {
      this.buttonDisabled = true;
      this.inProgress = true;
      let form = this.getForm();
      this.isSubmitted = false;
      // Check form is empty or not
      var isEmptyForm = true;
      this.responses.forEach(answer => {
        if (answer.content != "") {
          return (isEmptyForm = false);
        }
      });
      this.$store
        .dispatch(DECLARATION_FORM_SAVE, {
          form: form,
          formName: this.formName
        })
        .then(response => {
          window.scrollTo(0, 0);
          // Show form.submitted text when form is not empty
          if (!isEmptyForm) {
            this.isSubmitted = true;
          }
          this.inProgress = false;
          this.responses = [];
          this.showError = true;
          this.buttonDisabled = false;  // set back to false when form submission is complete
          if(this.ecosystemApp.application.type == 'Investor') {
            this.$router.push({
              name: "sessionlessDeclaration",
              params: {
                app_id: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id,
              }
            });
          } else {
            this.$router.push({
              name: "Declarations",
              params: {
                app_id: form.id
              }
           });
          }
        }).catch(error => {
          this.buttonDisabled = false;
        });
      this.inProgress = false;
    },
    // Debounced version of the saveForm function
    debouncedSaveForm: function() {
      this.saveForm();
    },
    getForm() {
      let finalResponses = [];
      Array.prototype.forEach.call(this.responses, final => {
        if (Array.isArray(final.content) && final.content.length === 0)
          final.content = "";
        if (final.content != null) {
          finalResponses.push(final);
        }
      });
      let form = {
        id: this.$route.params.ecoAppId,
        responses: finalResponses
      };
      if ((this.declarationForm.code_name === "INVESTOR_CALL_GUARANTEE_FORM" || this.getSharedData) && this.currentUser.role === "Investor") {
        form.relatedDeclaration = this.getSharedData;
        form.relatedDeclarationId = this.$route.params.id;
      }
      return form;
    },
    upperlace(string) {
      let result = string.replace(/-/g, "_");
      result = result.toUpperCase();

      return result;
    },

    getFormData() {
      this.$store
        .dispatch(DECLARATION_FORM_GET, {
          type: this.appType,
          formName: this.formName,
          hashId: this.ecoAppId
        })
        .then(data => {
          if(this.currentUser.role !== 'Investor') {
            if (this.ecosystemApp.application.user_id != this.currentUser.id) {
              this.isLeader = false;
            }
          } else {
            if (data.data.application.user_id != this.currentUser.id) {
              this.isLeader = false;
            }
          }
          this.showError = true;
        })
        .catch(error => {
          console.log(error);
          if(this.currentUser.role !== 'Investor')
          this.$router.push({ name: "home" });
          else {
            this.$router.push({
              name: "sessionlessDeclaration",
              params: {
                app_id: this.$route.params.app_id ?  this.$route.params.app_id : (this.ecosystemApp.application.hash_id ? this.ecosystemApp.application.hash_id : this.ecosystemApp.application.id),
              }
            });  
          }
        });
    }
  },
  computed: {
    ...mapGetters(["ecosystemApp", "declarationForm", "currentUser", "getSharedData"]),
    ...mapState({
      errors: state => state.request.errors
    }),
    currDec() {
      return this.getSharedData;
    },
    allDivisions() {
      if(this.relatedDivisions) return this.relatedDivisions;
    },
    allGroups() {
      if(this.relatedGroups) return this.relatedGroups;
    },
    allClasses() {
      if(this.relatedClasses) return this.relatedClasses;
    }
  },
  watch: {
    errors() {
      this.$Progress.fail();
    },
    declarationForm() {
      this.formData = this.declarationForm;
    }
  },
  beforeDestroy() {
    this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, false);
    // Remove the event listener when the component is destroyed
    this.$watch('$refs.submitButton', () => {
      if (this.$refs.submitButton) {
        this.$refs.submitButton.removeEventListener('click', this.debouncedSaveForm);
      }
    });
  },
  created() {
    const currDec = this.getCurrDec; // Access the current declaration data from the store
  },
};
</script>

<style></style>
